module.exports = __webpack_public_path__ + "static/media/oreo-dumpling.121025e7.png";